module.exports = __webpack_public_path__ + "static/feature-tracking-reminders-fbfb7112c78af47d3182a4f94504b0df.png";